(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* Las píldoras abren el cajón de filtros con on:click; aquí solo se decide
     qué filtro queda abierto dentro: el que se pulsó, y los demás plegados.
     Va delegado en document porque facets.js reemplaza la barra entera cada
     vez que se aplica un filtro. */
  document.addEventListener('click', (event) => {
    const boton = event.target.closest('[data-abrir-filtro]');
    if (!boton) return;

    requestAnimationFrame(() => {
      const cajon = document.getElementById('filters-drawer');
      if (!cajon) return;

      const id = boton.dataset.abrirFiltro;
      cajon.querySelectorAll('details.facets__panel').forEach((detalles) => {
        detalles.open = detalles.id === id;
      });
      cajon.querySelector(`#${CSS.escape(id)}`)?.scrollIntoView({ block: 'start' });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["history"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(scope){
    (scope || document).querySelectorAll('.stories-video').forEach(function(root){
      if(root.dataset.svInit) return;
      root.dataset.svInit = '1';
      var tpl = root.querySelector('[data-sv-tpl]');
      var modal = root.querySelector('[data-sv-modal]');
      var stage = root.querySelector('[data-sv-stage]');
      var openBtn = root.querySelector('[data-sv-open]');
      if(!tpl || !modal || !stage || !openBtn) return;

      function open(){
        stage.innerHTML = '';
        stage.appendChild(tpl.content.cloneNode(true));
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var v = stage.querySelector('video');
        if(v){ v.currentTime = 0; v.play().catch(function(){}); }
      }
      function close(){
        var v = stage.querySelector('video');
        if(v) v.pause();
        stage.innerHTML = '';
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      openBtn.addEventListener('click', open);
      modal.querySelectorAll('[data-sv-close]').forEach(function(el){ el.addEventListener('click', close); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !modal.hidden) close(); });
    });
  }
  if(document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["promo-timer-amatora"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function init(el) {
      if (el.dataset.ptInit) return;
      el.dataset.ptInit = '1';
      var desde = +el.dataset.desde || 0;
      var hasta = +el.dataset.hasta;
      var ciclo = (+el.dataset.repetir || 0) * 3600;
      var editor = el.hasAttribute('data-editor');
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]');
      var m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var timer = null;

      function tick() {
        var ahora = Date.now() / 1000;
        if (ciclo > 0 && ahora >= hasta) {
          /* Salta al siguiente fin de ciclo: fin original + k × ciclo */
          hasta += Math.ceil((ahora - hasta + 1) / ciclo) * ciclo;
        }
        if (!editor && (ahora < desde || ahora >= hasta)) {
          el.hidden = true;
          if (ahora >= hasta && timer) clearInterval(timer);
          return;
        }
        el.hidden = false;
        var r = Math.max(0, Math.floor(hasta - ahora));
        d.textContent = pad(Math.floor(r / 86400));
        h.textContent = pad(Math.floor((r % 86400) / 3600));
        m.textContent = pad(Math.floor((r % 3600) / 60));
        s.textContent = pad(r % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    }

    function initAll() {
      document.querySelectorAll('[data-promo-timer]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:block:select', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
